import FeesPage from './list/FeesPage.vue';

const routes = [
  {
    path: '/fees',
    name: 'fees',
    component: FeesPage,
    meta: {
      title: 'Finances',
      requiresAuth: true
    }
  }
];

export default routes;
